export {
    StyledAccordionItem,
    StyledAccordionContainer,
    StyledAccordionContent,
    StyledAccordionIconWrapper,
    StyledAccordionTrigger,
    StyledDefaultIcon,
} from './styles';
